module.exports = __webpack_public_path__ + "img/React.19165583.png";